<template>
  <nav class="sidebar-nav">
    <ul>
      <li>
        <router-link to="/dashboard" @click.native="closeSidebar"><i class='uil uil-home-alt'></i><span>Home</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/transactions" @click.native="closeSidebar"><i class='uil uil-invoice'></i><span>Transactions</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/payments" @click.native="closeSidebar"><i class='uil uil-money-stack'></i><span>Payments</span></router-link>
      </li>
      <li class="mb-30">
        <router-link to="/dashboard/disputes" @click.native="closeSidebar"><i class='uil uil-bolt'></i><span>Disputes</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/analysis" @click.native="closeSidebar"><i class='uil uil-analytics'></i><span>Analysis</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/risk-management" @click.native="closeSidebar"><i class='uil uil-life-ring'></i><span>Risk management</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/reporting" @click.native="closeSidebar"><i class='uil uil-file-copy-alt'></i><span>Reporting</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/schedule" @click.native="closeSidebar"><i class='uil uil-calendar-alt'></i><span>Schedule</span></router-link>
      </li>
      <li class="mb-30">
        <router-link to="/dashboard/notifications" @click.native="closeSidebar"><i class='uil uil-bell'></i><span>Notifications</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/virtual-terminal" @click.native="closeSidebar"><i class='uil uil-sliders-v-alt'></i><span>Virtual terminal</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/banking" @click.native="closeSidebar"><i class='uil uil-university'></i><span>Banking</span></router-link>
      </li>
      <li class="mb-30">
        <router-link to="/dashboard/contracts" @click.native="closeSidebar"><i class='uil uil-file-contract-dollar'></i><span>Contracts</span></router-link>
      </li>
      <li class="mb-30">
        <router-link to="/dashboard/features-suite" @click.native="closeSidebar"><i class='uil uil-package'></i><span>Features suite</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/ticketing" @click.native="closeSidebar"><i class='uil uil-envelope-question'></i><span>Ticketing</span></router-link>
      </li>
      <li>
        <router-link to="/dashboard/live-chat" @click.native="closeSidebar"><i class='uil uil-comments-alt'></i><span>Live chat</span></router-link>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: 'sidebar-nav',
  methods: {
    closeSidebar() {
      if (window.innerWidth < 992) {
        this.$store.commit('hideDashSide')
      }
    }
  }
}
</script>
